import { type UseQueryResult, useQuery } from 'react-query';
import { PlanService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetPlanGrantDocumentTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number | null;
    }>
  | undefined,
  unknown
> => {
  const planGrantDocumentTypes = useQuery(
    ['getPlanGrantDocumentTypes'],
    async () => {
      return await handleRequest(PlanService.getApiAwardApiAppPlanPlanDocumentTypes());
    },
    {
      select: (data) => {
        const options = data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });

        return options;
      },
    }
  );

  return planGrantDocumentTypes;
};

export default useGetPlanGrantDocumentTypes;
